<div class="container mat-background-default" *ngIf="locked">  
  <p class="message mat-body-strong">{{ 'WARNING.LOCKED' | translate }}</p>
  
  <button mat-icon-button matTooltip="{{ 'WARNING.REFRESH' | translate }}">
    <mat-icon>autorenew</mat-icon>
  </button>
  
</div>
